<template>
  <v-card
    elevation="1"
    class="card card-mobile mt-3"
    flat
    style="margin-left: 3rem; margin-right: 1rem; border-radius: 15px"
  >
    <Breadcrumbs
      :items="breadcrumbs"
      :page_title="$route.params.subName.toLowerCase()"
    />

    <Article
      v-if="$route.params.subName == 'Article'"
      ref="articleComponent"
      @itemsCount="getItem_No"
    />
    <!-- Article  $t('article')-->
    <Sound
      v-if="$route.params.subName == 'Sound'"
      ref="soundComponent"
      @itemsCount="getItem_No"
    />
    <!-- Sound $t('sound')-->
    <Video
      v-if="$route.params.subName == 'Video'"
      ref="videoComponent"
      @itemsCount="getItem_No"
    />
    <!-- Video $t('video') -->
  </v-card>
</template>

<script>
import Article from "./Article/ArticleIndex.vue";
import Sound from "./Sound/SoundIndex.vue";
import Video from "./Video/VideoIndex.vue";

export default {
  components: {
    Article,
    Sound,
    Video
  },
  data() {
    return {
      item_No: 0,
      breadcrumbs: [
        {
          // image: 'house.png',
          sidebar_title: "defaultcontent"
        },
        {
          text: "library",
          href: "/default-content/library"
        },
        {
          text: this.$route.query.topic_name, //this.$route.params.name
          href: "/default-content/library/data"
        },
        {
          text: this.$route.params.subName.toLowerCase()
        }
      ]
    };
  },
  methods: {
    ShowAction() {
      if (this.$route.params.subName == "Article") {
        this.$refs.articleComponent.checkArticleAdd();
      } else if (this.$route.params.subName == "Sound") {
        this.$refs.soundComponent.checkSoundAdd();
      } else if (this.$route.params.subName == "Video") {
        this.$refs.videoComponent.checkVideoAdd();
      }
    },
    getItem_No(value) {
      this.item_No = value;
    }
  }
};
</script>
